// extracted by mini-css-extract-plugin
module.exports = {"formItem":"InventoryStockAdjust_formItem__24FOl"};